import styled from 'styled-components'

export default styled.div`
  position: relative;
  height: 100%;

  .marker {
    font-family: ${ ({ theme }) => theme.fontFamily };
    font-size: 18px;
    letter-spacing: 0;
    line-height: 20px;
    color: ${ ({ theme }) => theme.colors.greyDark };
    padding: 0 12px 0 8px;
    user-select: none;
  }

  .gm-style .gm-style-iw-c {
    border-radius: 22px;
    cursor: pointer;

    > button {
      top: 8px !important;
    }
  }

  &.markers-options {
    visibility: hidden;
    height: 0;
  }

  .recenter-container {
    position: absolute;
    bottom: 55px;
    right: 5px;
    padding: 8px;
    border-radius: 50%;
    cursor: pointer;
    background-color: ${ ({ theme }) => theme.colors.white };
    
    img {
      width: 16px;
      height: 16px;
    }
  }

  .marker-infowindow {
    min-width: 150px;
    padding: 4px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    span {
      font-weight: bold;
    }
    .marker-dot {
      width: 16px;
      height: 16px;
      border-radius: 10px;
      position: relative;
    }

    .marker-white {
      position: absolute;
      top: 4px;
      left: 4px;
      width: 8px;
      height: 8px;
      border-radius: 5px;
      background-color: ${ ({ theme }) => theme.colors.white }
    }
  }
`
